<template>
  <!-- NOTE (TEMPLATE) to show all proposals -->

  <div class="animated fadeIn">
    <editUniRequestForm />
  </div>
</template>

<script>
import editUniRequestForm from "../../components/editUniRequestForm";
export default {
  components: { editUniRequestForm },
};
</script>
